module.exports = __webpack_public_path__ + "static/end-7e302715ca8c4d29658a2d07f3539b6c.png";